import { render, staticRenderFns } from "./NPSQuestion.vue?vue&type=template&id=2ceccfd8&scoped=true&"
import script from "./NPSQuestion.vue?vue&type=script&lang=js&"
export * from "./NPSQuestion.vue?vue&type=script&lang=js&"
import style0 from "./NPSQuestion.vue?vue&type=style&index=0&id=2ceccfd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceccfd8",
  null
  
)

export default component.exports